// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__9YlKJ","submitBtn":"styles_submitBtn__HcZyq","main":"styles_main__2RYSF","title":"styles_title__Q_DHw"};